import { componentsVisibility } from './componentsVisibilityCompNode'
import { componentsVisibilityDomApplier } from './componentsVisibilityDomApplier'
import { ComponentsVisibilityCssFeature } from './componentsVisibility.types'

export const editorComponentsVisibilityCssFeature: ComponentsVisibilityCssFeature = {
	experimentName: 'specs.thunderbolt.catharsis_editor_components_visibility',
	renderableNodes: { componentsVisibility },
	intermediateNodes: {},
	dataMaps: ['transformations_data', 'component_properties'],
	domApplier: componentsVisibilityDomApplier,
}
